"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MakerEnhanceClient;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function isBrowser() {
  return typeof window !== "undefined";
}
function run() {
  if (isBrowser() && window.MakerEmbeds && typeof window.MakerEmbeds.run === "function") {
    window.MakerEmbeds.run();
  }
}
function MakerEnhanceClient(_ref) {
  var user = _ref.user,
    id = _ref.id,
    scriptSrc = _ref.scriptSrc;
  var getUrl = function getUrl() {
    return isBrowser() ? window.location.href : undefined;
  };
  var _useState = (0, _react.useState)(getUrl()),
    _useState2 = _slicedToArray(_useState, 2),
    url = _useState2[0],
    setUrl = _useState2[1];
  (0, _react.useEffect)(function () {
    if (isBrowser() && user && !window.MakerEmbeds) {
      var script = document.createElement("script");
      script.id = "maker-enhance-script";
      script.src = scriptSrc;
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);
  var changeUrl = function changeUrl(newUrl) {
    setUrl(newUrl);
    var embed = document.querySelector("[data-orig-id=\"".concat(id, "\"]"));
    var placeholder = document.querySelector("#".concat(id));
    if (embed && embed.parentElement && placeholder && window.maker_enhance_engine) {
      var currentUrl = btoa(encodeURIComponent(window.maker_enhance_engine.page_url));
      var embedUrl = embed.getAttribute("data-maker-embed-id");
      if (currentUrl !== embedUrl) {
        embed.parentElement.removeChild(embed);
        placeholder.removeAttribute("data-maker-loaded");
      }
    }
    run();
  };
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      var newUrl = getUrl();
      if (newUrl !== url) {
        changeUrl(newUrl);
      }
    }, 100);
    return function () {
      clearInterval(interval);
    };
  }, [url, id]);
  (0, _react.useEffect)(function () {
    run();
  }, [id]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
}